import React, {FC} from 'react';

import {RoundButton} from '@optimaxdev/design-system';

import classNames from 'classnames';

import {AddressesFacelift} from '../../addressesFacelift/addressesFacelift';
import {ResumeStructureType} from '../utils';

import s from './deliveryStepResumeFacelift.scss';

type PropsType = {
    backToDeliveryStep: () => void;
    structure: ResumeStructureType;
};

/**
 * DeliveryStepResumeFacelift
 */
export const DeliveryStepResumeFacelift: FC<PropsType> = ({backToDeliveryStep, structure}) => {
    const {addresses, method} = structure;

    const getEditButton = () => {
        return (
            <RoundButton
                className={s.button}
                colorName="geyser"
                onClick={backToDeliveryStep}
                size="small"
                variant="painted"
                isFull
            >
                Edit
            </RoundButton>
        );
    };
    return (
        <>
            <div className={s.header}>
                <h2 className={s.title}>1. Shipping</h2>
            </div>

            <div className={s.sectionWrapper}>
                {addresses.map(addressItem => {
                    const {components, isBillingAddress, title} = addressItem;

                    return (
                        <div
                            className={classNames({
                                [s.billingAddress]: isBillingAddress,
                            })}
                            key={title}
                        >
                            <div className={s.headerWrapper}>
                                <h3 className={s.headerTitle}>
                                    {isBillingAddress ? 'Billing' : 'Shipping'} address
                                </h3>
                                {getEditButton()}
                            </div>
                            <AddressesFacelift addresses={components} />
                        </div>
                    );
                })}

                <div className={s.shippingMethod}>
                    <div className={s.headerWrapper}>
                        <h3 className={s.headerTitle}>Shipping method</h3>
                        {getEditButton()}
                    </div>
                    <div className={s.content}>
                        <p>{method}</p>
                    </div>
                </div>
            </div>
        </>
    );
};
